import React from 'react'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ className, column, data, tbodyStyle }) => {
  const _columns = column()

  return <div className={className}>
    <table className={classNames(styles['mn-simple-table'])}>
      <thead className={styles['mn-simple-table-thead']}>
        <tr>
          {
            _columns.map(col => <th style={{ width: col.width }} className="mn-simple-table-thead-th">{col.title}</th>)
          }
        </tr>
      </thead>
    </table>
    <div style={{ ...tbodyStyle }}>
      <tbody className={styles['mn-simple-table-tbody']}>
        {
          data.map((item, index) => <tr className="mn-simple-table-tbody-tr" key={index}>
            {
            _columns
              .map((col) => <td className="mn-simple-table-tbody-td" style={{ width: col.width }}>{
                col.render
                  ? col.render(item[col.dataIndex], item) : item[col.dataIndex]
                }</td>)
            }
          </tr>)
          }
      </tbody>
    </div>
    <table className={classNames(styles['mn-simple-table'])}>
      <tfoot className={styles['mn-simple-table-tfoot']}>
        <tr>
          {
            _columns.map(col => <th style={{ width: col.width }} className="mn-simple-table-tfoot-th">{col?.footer?.render ? col?.footer?.render() : col?.footer?.title}</th>)
          }
        </tr>
      </tfoot>
    </table>
  </div>
}
